module.exports = __webpack_public_path__ + "static/media/crisis-situations-large@3x.d410edd5.png";